// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"69f8b221","118":"d2d35fd1","311":"f7bd89e7","418":"5521af21","489":"9a7eb1fe","787":"4dfac312","896":"ff815acb"}[chunkId] + ".chunk.js";
};